var blockedDates = [ 
  "2025-11-17",
  "2025-11-18",
  "2025-11-19",
  "2025-11-20",
  "2025-11-21",
  "2025-12-01",
  "2025-12-02",
  "2025-12-03",
  "2025-12-08",
  "2025-12-11",
  "2025-12-12",
  "2025-12-13",
  "2025-12-21",
  "2025-12-22",
  "2025-12-23",
  "2025-12-24",
  "2025-12-25",
  "2025-12-26",
  "2025-12-27",
  "2025-12-28",
  "2025-12-29",
  "2025-12-30",
  "2025-12-31",
  "2026-01-01",
  "2026-01-02",
  "2026-01-03",
  "2026-01-04",
  "2026-01-05",
  "2026-01-06",
  "2026-01-07",
  "2026-01-08",
  "2026-01-09",
  "2026-01-10",
  "2026-01-11",
  "2026-01-12",
  "2026-01-13",
  "2026-01-14",
  "2026-01-15",
  "2026-01-10"
];

var limitedTimeDates = [ 
  "2025-11-17",
  "2025-11-18",
  "2025-11-19",
  "2025-11-20",
  "2025-11-21",
  "2025-11-22",
  "2025-11-24",
  "2025-11-25", 
  "2025-11-26",
  "2025-11-27",
  "2025-11-28",
  "2025-11-29",
  "2025-11-30",
  "2025-12-01",
  "2025-12-02",
  "2025-12-03",
  "2025-12-08",
  "2025-12-11",
  "2025-12-12",
  "2025-12-13",
  "2025-12-25",
  "2025-12-26",
  "2025-12-27",
  "2025-12-28",
  "2025-12-29",
  "2025-12-30",
  "2025-12-31",
  "2026-01-01",
  "2026-01-02",
  "2026-01-03",
  "2026-01-04",
  "2026-01-05",
  "2026-01-06",
  "2026-01-07",
  "2026-01-08",
  "2026-01-09",
  "2026-01-10",
  "2026-01-11",
  "2026-01-12",
  "2026-01-13",
  "2026-01-14",
  "2026-01-15"
];
